import { CoachingEventStatus } from '../../coaching-base/general';
import { RepCardData } from '../models/rep-card-data.model';

export function overrideActiveDate(
    opps: RepCardData[],
    data: RepCardData[],
): void {
    if (opps == null) {
        return;
    }
    opps.forEach((c) => {
        if (c.statusId === CoachingEventStatus.DISPUTED) {
            const cmt = data.find(
                (e) => e.statusId === CoachingEventStatus.ACTIVE,
            );
            c.activeDate = cmt?.activeDate;
        }
    });
}
